import { Component } from 'react';
import { NavLink, withRouter, Link, matchPath } from 'react-router-dom';
import { connect } from 'react-redux';
import routesPath from 'Constants/routes.constants';
import Brandimage from 'assets/images/DAZAPP-Logo (1).svg';
import yabsysText from 'assets/images/Daz App.svg';
import { ModuleActions, Modules } from 'Constants/Modules.constants';

// sidebar menu icon code start here ********************/
import { ReactComponent as DashboardActive } from 'assets/images/svg/sidebar_menu_icon/Frame (5).svg';
import { ReactComponent as DashboardInactive } from 'assets/images/svg/sidebar_menu_icon/Frame (4).svg';
import { ReactComponent as UserActive } from 'assets/images/svg/sidebar_menu_icon/Frame (7).svg';
import { ReactComponent as UserInactive } from 'assets/images/svg/sidebar_menu_icon/Frame (6).svg';
import { ReactComponent as GroupActive } from 'assets/images/svg/sidebar_menu_icon/Frame (9).svg';
import { ReactComponent as GroupInactive } from 'assets/images/svg/sidebar_menu_icon/Frame (8).svg';
import { ReactComponent as CallActive } from 'assets/images/svg/sidebar_menu_icon/Frame (11).svg';
import { ReactComponent as CallInactive } from 'assets/images/svg/sidebar_menu_icon/Frame (10).svg';
import { ReactComponent as AdminActive } from 'assets/images/svg/sidebar_menu_icon/Frame (13).svg';
import { ReactComponent as AdminInactive } from 'assets/images/svg/sidebar_menu_icon/Frame (12).svg';
import { ReactComponent as FeedbackActive } from 'assets/images/svg/sidebar_menu_icon/feedback_active.svg';
import { ReactComponent as FeedbackInactive } from 'assets/images/svg/sidebar_menu_icon/feedback_inctive.svg';
import { ReactComponent as SettingsActive } from 'assets/images/svg/sidebar_menu_icon/Frame (15).svg';
import { ReactComponent as SettingsInactive } from 'assets/images/svg/sidebar_menu_icon/Frame (14).svg';
import { ReactComponent as AccessControlActive } from 'assets/images/svg/sidebar_menu_icon/access_control_active.svg';
import { ReactComponent as AccessControlInactive } from 'assets/images/svg/sidebar_menu_icon/access_control_inactive.svg';
import { ReactComponent as BroadcastActive } from 'assets/images/svg/sidebar_menu_icon/broadcast_active.svg';
import { ReactComponent as BroadcastInactive } from 'assets/images/svg/sidebar_menu_icon/broadcast_inactive.svg';
import { ReactComponent as ManageBroadcastActive } from 'assets/images/svg/sidebar_menu_icon/manage_broadcast_active.svg';
import { ReactComponent as ManageBroadcastInactive } from 'assets/images/svg/sidebar_menu_icon/manage_broadcast_inactive.svg';
import { ReactComponent as TeamActive } from 'assets/images/svg/sidebar_menu_icon/team_active.svg';
import { ReactComponent as TeamInactive } from 'assets/images/svg/sidebar_menu_icon/team_inactive.svg';
import { ReactComponent as ManageAdminActive } from 'assets/images/svg/sidebar_menu_icon/Frame (19).svg';
import { ReactComponent as ManageAdminInactive } from 'assets/images/svg/sidebar_menu_icon/Frame (18).svg';
import { ReactComponent as ManageAdminRoleActive } from 'assets/images/svg/sidebar_menu_icon/Frame (17).svg';
import { ReactComponent as ManageAdminRoleInactive } from 'assets/images/svg/sidebar_menu_icon/Frame (16).svg';
import { ReactComponent as ReportActive } from 'assets/images/Frame (17).svg';
import { ReactComponent as ReportInactive } from 'assets/images/Frame (16).svg';
class SideMenu extends Component {

  state = {
    isAdminMenuOpen: false,
  };

  toggleAdminMenu = () => {
    this.setState(prevState => ({
      isAdminMenuOpen: !prevState.isAdminMenuOpen,
    }));
  };

  toggle = () => {
    // toggling the classlist of sidemenu only if the maincontainer is been expanded by adding "collaps" class
    if(document.getElementById('maincontainer').classList.contains('collaps')){
      document.getElementById('sidemenu').classList.toggle('close');
    }
  };
  getNavLinkClass = (path, isSublink) => {
    let pathname = this.props.location.pathname;
    let isPathMatch = false;
    if(path === '/'){
      isPathMatch = path === pathname;
    }
    else{
      isPathMatch = matchPath(pathname, { path });
    }

    if(isSublink){
      return isPathMatch ? 'active' : '';
    }
    return isPathMatch ? 'sList_item-active' : '';
  };

  getlevelmenuClass = path => {
    if(path.includes('User/UserManagement')) {
      return this.props.location.pathname.includes(path) ? 'levelmenu' : '';
    }
    return (this.props.location.pathname === path) ? 'levelmenu' : '';
  }

  render() {
    const { 
      [ Modules.dashboard ]: Dashboard, 
      [ Modules.users ]: Users,
      [ Modules.groups ]: Groups, 
      [ Modules.broadcast ]: Broadcast,
      [ Modules.team ]: Team,
      [ Modules.callManagement ]: Callmanagement, 
      [ Modules.manageAdmin ]: Adminuser, 
      [ Modules.manageAdminRoles ]: Roles, 
      [ Modules.settings ]: Settings, 
      [ Modules.feedback ]: Feedback,
      [ Modules.help ]: help, 
      [ Modules.appAccessControl ]: AppAccessControl, 
    } =
    this.props.profile.permission && JSON.parse(this.props.profile.permission) || {};
    const isBroadcastActive = this.getNavLinkClass(routesPath.manageBroadcast) || this.getNavLinkClass(routesPath.broadcastTeam) || this.getNavLinkClass(routesPath.broadcastTeamEdit());
     const { isAdminMenuOpen } = this.state;
    return (
      <>
        <div className='sidebarNav sidebarNav-active' id='sidemenu1' >
        <div className='sidebarNav_logo'>
            <span><img alt='Yabsys' width="120" src={ Brandimage } /></span>
            {/* <span><img alt='Yabsys' width="70"  src={ yabsysText } /></span> */}
            {/* <span className='DazWay-title'>DazWay</span> */}
        </div>
          <ul className='sidebarNav_sList sList'>
            <li className={ `sList_item ${ this.getNavLinkClass('/') }` }>
              <NavLink
                className='sList_item_link'
                exact
                activeClassName='active1'
                to={ routesPath.root }
              >
                {this.getNavLinkClass('/') ? <DashboardActive /> : <DashboardInactive />}
                <span>Dashboard</span>
              </NavLink>
            </li>
            { (Users && Users[ ModuleActions.view ]) && (
            <li className={ `sList_item ${ this.getNavLinkClass(routesPath.userManagement) }` }>
              <NavLink className='sList_item_link' activeClassName='active1' to={ routesPath.userManagement }>
                { this.getNavLinkClass(routesPath.userManagement) ? <UserActive /> : <UserInactive /> }
                <span> Users </span>
              </NavLink>
              </li>
            )}
            { AppAccessControl && AppAccessControl[ ModuleActions.view ] && 
            <li className={ `sList_item ${ this.getNavLinkClass(routesPath.appAccessControl) }` }>
              <NavLink className='sList_item_link appAccess_menu_icon' to={ routesPath.appAccessControl }>
                { this.getNavLinkClass(routesPath.appAccessControl) ? <AccessControlActive /> : <AccessControlInactive /> }
                <span> App Access Control </span>
              </NavLink>
              </li> }
            { Groups && Groups[ ModuleActions.view ] && (
            <li className={ `sList_item ${ this.getNavLinkClass(routesPath.groups) || this.getNavLinkClass(routesPath.groupInfoWithId()) }` }>
              <NavLink
                className='sList_item_link group_menu_icon'
                activeClassName='active1'
                to={ routesPath.groups }
              >
                { this.getNavLinkClass(routesPath.groups) || this.getNavLinkClass(routesPath.groupInfoWithId()) ? <GroupActive /> : <GroupInactive /> }
                <span> Groups</span>
              </NavLink>
            </li>
          )}
          { ((Broadcast && Broadcast[ ModuleActions.view ] ) || (Team && Team[ ModuleActions.view ])) &&  (
            <li className={ `sList_item ${ this.getNavLinkClass(routesPath.manageBroadcast) || this.getNavLinkClass(routesPath.broadcastTeam) || this.getNavLinkClass(routesPath.broadcastTeamEdit()) }` }>
              <NavLink className='sList_item_link' to={ Broadcast?.[ ModuleActions.view ]  ? routesPath.manageBroadcast : (Team?.[ ModuleActions.view ]  ? routesPath.broadcastTeam : '') }>
                { isBroadcastActive ? <BroadcastActive /> : <BroadcastInactive /> }
                <span> Broadcast</span>
                <i className='arrowIcon'>
                  <svg  width="20" height="20" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>
                </i>
              </NavLink>
              <ul>
              { Broadcast && Broadcast[ ModuleActions.view ] && (
                <li className={ `sList_item ${ this.getNavLinkClass(routesPath.manageBroadcast, true) }` }>
                  <Link className='sList_item_link' to={ routesPath.manageBroadcast }>
                    { this.getNavLinkClass(routesPath.manageBroadcast, true) ? <ManageBroadcastActive /> : <ManageBroadcastInactive /> }
                    <span> Manage Broadcast</span>
                  </Link>
                </li>
              )}
              { Team && Team[ ModuleActions.view ] && (
                <li className={ `sList_item ${ this.getNavLinkClass(routesPath.broadcastTeam, true) || this.getNavLinkClass(routesPath.broadcastTeamEdit(), true) }` }>
                  <Link className='sList_item_link' to={ routesPath.broadcastTeam }>
                  { this.getNavLinkClass(routesPath.broadcastTeam, true) || this.getNavLinkClass(routesPath.broadcastTeamEdit(), true) ? <TeamActive /> : <TeamInactive /> }
                    <span>Team</span>
                  </Link>
                </li>
                  )}
              </ul>
            </li>
              )}
          { Callmanagement && Callmanagement[ ModuleActions.view ] && (
            <li className={ `sList_item ${ this.getNavLinkClass(routesPath.callManagement) }` }>
              <NavLink
                className='sList_item_link'
                activeClassName='active1'
                to={ routesPath.callManagement }
              >
              { this.getNavLinkClass(routesPath.callManagement) ? <CallActive /> : <CallInactive /> }
              <span> Call Management</span>
              </NavLink>
            </li>
          )}
          { 
          ((Adminuser && Adminuser[ ModuleActions.view ]) || (Roles && Roles[ ModuleActions.view ])) && (
        <li
          className={ `sList_item ${ isAdminMenuOpen ? 'sList_item-active' : '' } ` }
        >
          <div className='sList_item_link' onClick={ this.toggleAdminMenu }>
            { (this.getNavLinkClass(routesPath.manageAdmin) || this.getNavLinkClass(routesPath.manageAdminRoles))
              ? <AdminActive />
              : <AdminInactive />}
            <span> Admin</span>
            <i className='arrowIcon'>
              <svg width="20" height="20" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
              </svg>
            </i>
          </div>
          <ul style={ { display: isAdminMenuOpen ? 'block' : 'none' } }>
            { Adminuser && Adminuser[ ModuleActions.view ] && (
              <li className={ `sList_item ${ this.getNavLinkClass(routesPath.manageAdmin, true) } ` }>
                <Link className='sList_item_link' to={ routesPath.manageAdmin }>
                  { this.getNavLinkClass(routesPath.manageAdmin, true)
                    ? <ManageAdminActive />
                    : <ManageAdminInactive /> }
                  <span>Manage Admin</span>
                </Link>
              </li>
            )}
            {Roles && Roles[ ModuleActions.view ] && (
              <li className={ `sList_item ${ this.getNavLinkClass(routesPath.manageAdminRoles, true) } ` }>
                <Link className='sList_item_link' to={ routesPath.manageAdminRoles }>
                  { this.getNavLinkClass(routesPath.manageAdminRoles, true)
                    ? <ManageAdminRoleActive />
                    : <ManageAdminRoleInactive /> }
                  <span> Manage Admin Roles</span>
                </Link>
              </li>
            )}
          </ul>
        </li>
      )
          }
          { Feedback && Feedback[ ModuleActions.view ] && (
            <li className={ `sList_item ${ this.getNavLinkClass(routesPath.feedback) }` }>
              <NavLink
                className='sList_item_link'
                activeClassName='active1'
                to={ routesPath.feedback }
              >
                { this.getNavLinkClass(routesPath.feedback) ? <FeedbackActive /> : <FeedbackInactive /> }
                <span> Feedback</span>
              </NavLink>
            </li> )}
            {/* { help && help.view && (<li>
              <NavLink
                className='main-link'
                activeClassName='active'
                to={ routesPath.help }
              >
                <i className='MenuIcon'>
                  <svg width='12.96' height='16.2' viewBox='0 0 12.96 16.2'>
                    <path d='M2.719,14.924l.01-.007A3.227,3.227,0,0,1,0,11.681a.925.925,0,0,1,.009-.1V.338A.331.331,0,0,1,.333,0h12.3a.331.331,0,0,1,.324.338V15.525a.662.662,0,0,1-.648.675Zm2.2-4.607,6.423,3.926V1.687H1.628v9.947c0,.03,0,.073,0,.1A1.492,1.492,0,0,0,3.134,13.26a1.546,1.546,0,0,0,1.511-1.579c0-.019,0-.037,0-.057v-1.15c0-.129.059-.2.144-.2A.239.239,0,0,1,4.918,10.317ZM3.138,7.5V6.486H9.812V7.5Zm0-2.425V4.061H9.812V5.071Z' />
                  </svg>
                </i>
                <span> Help </span>
              </NavLink>
            </li>
          )} */}
           <li className={ `sList_item ${ this.getNavLinkClass(routesPath.report) }` }>
              <NavLink
                className='sList_item_link'
                activeClassName='active1'
                to={ routesPath.report }
              >
              { this.getNavLinkClass(routesPath.report) ? <ReportActive /> : <ReportInactive /> }
              <span>Reports</span>
              </NavLink>
            </li>
            { Settings && Settings[ ModuleActions.view ] && (
            <li className={ `sList_item ${ this.getNavLinkClass(routesPath.settings) }` }>
              <NavLink className='sList_item_link' activeClassName='active'  to={ routesPath.settings }>
                { this.getNavLinkClass(routesPath.settings) ? <SettingsActive /> : <SettingsInactive /> }
                <span>Settings</span>
              </NavLink>
            </li>
            )}
          </ul>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { profile } = state;
  return { profile };
}
export default connect(mapStateToProps, null)(withRouter(SideMenu));